<form class="row">
  <label for="fromDateInput" class="form-label">
    <ng-container i18n="@@upp.global.ruleDateRange.dateRangeLabel">Date range</ng-container>
    <span class="mandatory ms-1">*</span>
  </label>
  <div
    class="date-range-wrapper col-lg-4"
    [placement]="'bottom'"
    [autoClose]="'outside'"
    ngbDropdown
    #drop1="ngbDropdown"
    (openChange)="onCalendarToggle($event)"
    data-test="dateRangeSelect"
  >
    <div class="d-flex flex-nowrap" dfDatepickerRange>
      <div class="input-group w-50">
        <input
          id="datepicker-singlerange-from-date1"
          #fromDateInputField
          class="form-control"
          [(ngModel)]="dfDatepickerRangeService.fromDate"
          #fromDateModel="ngModel"
          placeholder="DD/MM/YYYY"
          name="fromDateInput"
          ngbDatepicker
          #fromDateInput="ngbDatepicker"
          (input)="onFromDateInput(fromDateInputField.value)"
          [disabled]="readonly"
          [ngClass]="{ 'is-invalid': startDateControl?.invalid && startDateControl?.touched }"
        />
        <div class="input-group-append">
          <span class="input-group-text fa-light fa-long-arrow-right" (click)="fromDateInputField.focus()">
            <span class="visually-hidden">Focus to Date</span>
          </span>
        </div>
      </div>

      <div class="input-group w-50">
        <input
          id="datepicker-singlerange-to-date1"
          #toDateInputField
          class="form-control"
          [(ngModel)]="dfDatepickerRangeService.toDate"
          #toDateModel="ngModel"
          placeholder="DD/MM/YYYY"
          name="toDateInput"
          ngbDatepicker
          #toDateInput="ngbDatepicker"
          (input)="onToDateInput(toDateInputField.value)"
          [disabled]="readonly"
        />
        <div class="input-group-append">
          <button
            #buttonTofocus1
            class="input-group-text fa-light fa-calendar"
            type="button"
            (click)="dfDatepickerRangeService.toggle(drop1, buttonTofocus1, datepicker1)"
            [disabled]="readonly"
            ngbDropdownAnchor
            aria-controls="dropdownMenu"
            data-test="calendarIconButton"
          >
            <span class="visually-hidden">Toggle datepicker</span>
          </button>
        </div>
      </div>
    </div>

    <div
      ngbDropdownMenu
      class="df-datepicker-range-dropdown"
      id="dropdownMenu"
      placement="left"
      data-test="calendarDropdown"
    >
      <ngb-datepicker
        #datepicker1="ngbDatepicker"
        class="show"
        [displayMonths]="3"
        [dayTemplate]="dayTemplate1"
        [footerTemplate]="footer"
        [outsideDays]="'collapsed'"
        [navigation]="'arrows'"
        [showWeekNumbers]="false"
        [startDate]="getNgbDpStartDate(dfDatepickerRangeService.startDate)"
        (dateSelect)="dfDatepickerRangeService.onDateSelection($event)"
      >
        <ng-template #dayTemplate1 let-date let-disabled="disabled" let-focused="focused" let-selected="selected">
          <div
            class="df-datepicker-date"
            [class.df-datepicker-date-disabled]="disabled"
            [class.df-datepicker-date-selected]="dfDatepickerRangeService.isSelected(date)"
            [class.df-datepicker-date-from]="dfDatepickerRangeService.isFrom(date)"
            [class.df-datepicker-date-to]="dfDatepickerRangeService.isTo(date)"
            [class.df-datepicker-date-between]="dfDatepickerRangeService.isBetween(date)"
            (mouseenter)="dfDatepickerRangeService.hoveredDate = date"
            (mouseleave)="dfDatepickerRangeService.hoveredDate = null"
          >
            {{ date.day }}
          </div>
        </ng-template>
        <ng-template #footer>
          <div class="activate-on-header">
            <p class="activate-on-title">Activate on </p>
            <p>
              <span class="fa-info-circle ms-3 me-3"></span>
              <span class="activate-on-disclaimer"
                >If you don't select any days, you will activate the rule for the whole date range</span
              >
            </p>
          </div>
          <hr />
          <div>
            <ul class="frequency">
              @for (weekDay of validityApplicationWeekdays; track weekDay) {
              <li>
                <input
                  type="checkbox"
                  [id]="weekDay.value"
                  (click)="toggleDay(weekDay.value, $event)"
                  [checked]="selectedWeekdays.includes(weekDay.value)"
                />
                <label class="weekday-label" [for]="weekDay.value">{{ weekDay.displayName }}</label>
              </li>
              }
            </ul>
          </div>
        </ng-template>
      </ngb-datepicker>
    </div>
    <div class="selected-days-badges">
      @for (badge of getBadges(); track badge) {
      <span class="badge rounded-pill bg-light">
        {{ badge }}
      </span>
      }
    </div>
  </div>
  @if (fromDateModel.status === 'INVALID' || toDateModel.status === 'INVALID' ||
  applicabilityFormGroup.errors?.invalidDateRange || (!readonly && startDateControl?.touched &&
  !startDateControl?.value?.length)) {
  <div class="validation-error-message" class="invalid mt-1" data-test="error-message">
    @if (fromDateModel.status === 'INVALID') {
    <span i18n="@@upp.global.ruleDateRange.validation.invalidStartDate"> Please enter a valid start date format </span>
    } @else if (toDateModel.status === 'INVALID') {
    <span i18n="@@upp.global.ruleDateRange.validation.invalidEndDate"> Please enter a valid end date format </span>
    } @else if (applicabilityFormGroup.errors?.invalidDateRange) {
    <span i18n="@@upp.global.ruleDateRange.validation.invalidDateRange"> Please enter a valid date range </span>
    } @else if (!readonly && startDateControl?.touched && !startDateControl?.value?.length) {
    <span i18n="@@upp.validation.required">
      {{ REQUIRED_MSG }}
    </span>
    }
  </div>
  }
</form>
